import { Controller } from "@hotwired/stimulus";

// « Paid, not on a circuit yet » (GO4SFLEET): the « Affecter » link follows
// the circuit picked in its row, to the assignment form with the student
// already chosen.
export default class extends Controller {
  static targets = ["circuit", "link"];

  connect() {
    this.update();
    this.circuitTarget.addEventListener("change", () => this.update());
  }

  update() {
    const url = new URL(this.linkTarget.href, window.location.origin);
    url.pathname = url.pathname.replace(/\/circuits\/\d+\//, `/circuits/${this.circuitTarget.value}/`);
    this.linkTarget.href = url.pathname + url.search;
  }
}
